import styles from "./MeetingLinkRecipientsWarningMessage.module.scss";
import { copyToClipboard } from "../../../common/utilities/clipboardUtility";
import {
  getErrorToast,
  getSuccessToast,
} from "../../../common/infrastructure/utilities/toastUtility";
import { IMeetingLinkRecipientWithoutEmail } from "./models/meetingLinkRecipientsModel";

interface IMeetingLinkRecipientsWarningMessageProps {
  clients: IMeetingLinkRecipientWithoutEmail[];
  meetingUrl?: string | null;
}

/**
 * The body of the dialog staff see after saving a remote event's reservations when a client has
 * no email: who will not get the Google Meet link, and the link to pass on by hand. Names are user
 * data, so they are rendered as React text, never as HTML.
 */
export const MeetingLinkRecipientsWarningMessage = ({
  clients,
  meetingUrl,
}: IMeetingLinkRecipientsWarningMessageProps) => {
  const url = meetingUrl?.trim();

  const onCopyClick = async () => {
    if (!url) return;

    const success = await copyToClipboard(url);

    if (success) {
      getSuccessToast("Линкът е копиран в клипборда!");
    } else {
      getErrorToast("Грешка при копиране на линка");
    }
  };

  return (
    <div className={styles.root}>
      {clients.length === 1 ? (
        <p className={styles.text}>
          Клиентът <b>{clients[0].name}</b> няма имейл и не може да получи
          линка към срещата.
        </p>
      ) : (
        <>
          <p className={styles.text}>
            Тези клиенти нямат имейл и не могат да получат линка към срещата:
          </p>
          <ul className={styles.names}>
            {clients.map((client) => (
              <li key={client.userId}>{client.name}</li>
            ))}
          </ul>
        </>
      )}

      {url && (
        <div className={styles.link}>
          <p className={styles.link_label}>Дайте им линка ръчно:</p>
          <span className={styles.link_url}>{url}</span>
          <button
            className={styles.link_copy}
            type="button"
            onClick={onCopyClick}
          >
            Копирай линка
          </button>
        </div>
      )}
    </div>
  );
};
